import { IFeathersDefaultFilters, IFeathersResponse } from 'src/types/feathers.types'
import fetch from 'src/utils/fetchToken'
import fetchService from 'src/utils/fetchToken'

const AuthMandatEndpoint = `${process.env.REACT_APP_API_URL}/auth-mandat`

export interface identification {
  clientId: string
  email: string
}

export interface clientInfo {
  id?: number
  code: number
  clientId: string
  email: string
  clientInfo?: {
    firstname: string
    lastname: string
    num_client: number
    denomination: string
    adresse: string
    codePostal: string
    localite: string
    pays: string
    mobile: string
    email: string
    depot: string
    dateFermeture: string | null
    siret: string
    createdAt: string
    updatedAt: string
  }
}

export const sendOtpCode = async (clientId: identification): Promise<IFeathersResponse<identification>> => {
  return fetch(`${AuthMandatEndpoint}`, 'POST', clientId)
}

export const validateOtpCode = async (code: clientInfo): Promise<clientInfo> => {
  return fetch(`${AuthMandatEndpoint}`, 'PATCH', code)
}

export const signatureStatus = async (signatureRequestId: string): Promise<{ status: string }> => {
  return fetch(`${AuthMandatEndpoint}/signature-status/${signatureRequestId}`, 'GET')
}